import * as Sentry from '@sentry/browser';

/**
 * @param {string} key
 * @param {string} value
 * @return {void}
 */
export const setSession = (key, value) => {
  window.sessionStorage.setItem(key, value);
};

/**
 * @param {string} key
 * @return {string|null}
 */
export const getSession = (key) => window.sessionStorage.getItem(key);

/**
 * @param {array} keys
 * @return {void}
 */
export const clearSessionKeys = (keys) => keys
  .forEach((key) => window.sessionStorage.removeItem(key));

export const setErrorReportingData = (tokenType, token) => {
  Sentry.configureScope((scope) => {
    scope.setUser({
      id: `${tokenType}:${token}`,
    });
  });
};
